module.exports = __webpack_public_path__ + "static/media/background.3611ac58.png";